var _defs, _rect, _g, _g2, _circle, _circle2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventrix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eventrixBg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5B4FE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2D1F8A"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 38,
    fill: "url(#eventrixBg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 50,
    x2: 200,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 100,
    x2: 200,
    y2: 100
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 150,
    x2: 200,
    y2: 150
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 0,
    x2: 100,
    y2: 200
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 0,
    x2: 150,
    y2: 200
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 18,
    height: 100,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 80,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 91,
    width: 58,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 132,
    width: 80,
    height: 18,
    rx: 4
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 100,
    r: 11,
    fill: "#0EA89E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 100,
    r: 4,
    fill: "#0a0a0f"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    stroke: "rgba(255,255,255,0.4)",
    strokeWidth: 3,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 156,
    y1: 156,
    x2: 172,
    y2: 172
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172,
    y1: 156,
    x2: 156,
    y2: 172
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventrix);
export default __webpack_public_path__ + "static/media/eventrix.df9622dbc5036ebf722f493c25875c05.svg";
export { ForwardRef as ReactComponent };